<template>
  <div>
    <q-dialog maximized :value="show" @hide="$emit('update:show', false)">
      <div class="vpage pc-width-pull-full">
        <!--Header-->
        <div class="vpage-header">
          <div class="vpage-header-back" @click="$emit('update:show', false)">
            <q-icon v-close-popup class="detail-head-close" name="svg:oclose" />
          </div>
        </div>
        <!--Main-->
        <div class="vpage-main">
          <!--Search Bar-->
          <div class="img-box">
            <q-img src="~assets/images/download.jpg" class="img-icon" alt="" />
<!--            <span class="slogan">{{ $t('order.download.slogan') }}</span>-->
          </div>

          <div class="header">
            <div class="title">{{ $t('order.download.header.title') }}</div>
            <p class="desc">{{ $t('order.download.header.desc') }}</p>
          </div>

          <div class="content">
            <div class="title">{{ $t('order.download.content.title') }}</div>
            <div class="desc-box">
              <p class="desc">1. {{ $t('order.download.content.desc1') }}</p>
              <p class="desc">2. {{ $t('order.download.content.desc2') }}</p>
              <p class="desc">3. {{ $t('order.download.content.desc3') }}</p>
            </div>
          </div>

          <div class="content">
            <div class="title">{{ $t('order.download.content.title1') }}</div>
            <div class="desc-box">
              <p class="desc">- {{ $t('order.download.content.desc4') }}</p>
              <p class="desc">- {{ $t('order.download.content.desc5') }}</p>
              <p class="desc">- {{ $t('order.download.content.desc6') }}</p>
<!--              <p class="desc">- {{ $t('order.download.content.desc7') }}</p>-->
              <p class="desc">- {{ $t('order.download.content.desc8') }}</p>
              <p class="desc">- {{ $t('order.download.content.desc9') }}</p>
              <p class="desc">- {{ $t('order.download.content.desc10') }}</p>
            </div>
          </div>
        </div>

        <div class="vpage-footer">
          <div class="footer-btn danger" @click="onClickDownloadBtn">
            {{ $t('order.download.downloadBtn') }}
          </div>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import { getDeviceType } from 'src/utils/common';
import { mapState } from 'vuex';

export default {
  props: {
    show: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState({
      storeInfo: state => state.prefetch.storeInfo,
    })
  },
  methods: {
    onClickDownloadBtn($val) {
      window.open(`https://horego.onelink.me/BDBE?af_xp=custom&pid=voucherQR&c=voucherqr-${this.storeInfo.url}&deep_link_value=horego%3A%2F%2Fdeeplink%2Fopenscreen&af_dp=horego%3A%2F%2Fdeeplink%2Fopenscreen`, '_blank');
      this.$emit('download');
      this.$emit('update:show', false);
    },
  },
};
</script>

<style scoped lang="scss">
.vpage {
  font-family: GothamOffice;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  padding-top: 48px;
  background: #fff;
  &-header {
    height: 48px;
    background: $headBg;
    position: absolute;
    top: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 16px;
    font-family: 'Poppins';
  }
  &-main {
    height: calc(100% - 76px);
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden auto;
    padding-bottom: 16px;
    .img-box {
      width: 100%;
      height: 180px;
      position: relative;
    }

    .slogan {
      position: absolute;
      left: 24px;
      top: 50%;
      transform: translateY(-50%);

      width: 128px;
      height: 48px;
      color: var(--Secondary-Eerie-Black-White, var(--white, #fff));
      font-size: 16px;
      font-style: normal;
      font-weight: 900;
      line-height: normal;
    }
    .img-icon {
      height: 180px;
      width: 100%;
      object-fit: cover;
    }
    .header {
      padding: 16px;
      border-bottom: 4px solid #f5f5f5;
      .title {
        overflow: hidden;
        color: var(--Secondary-Eerie-Black-Default, #232323);
        text-overflow: ellipsis;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-bottom: 4px;
        text-align: left;
      }
      .desc {
        overflow: hidden;
        color: var(--Primary-Colors-text, #1f2d3e);
        text-overflow: ellipsis;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-align: left;
        margin: 0;
      }
    }
    .content {
      .title {
        padding: 12px 16px;
        color: var(--Secondary-Eerie-Black-Default, #232323);
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-align: left;
      }
      .desc-box {
        padding: 12px 16px;
        .desc {
          text-align: left;
          color: var(--Secondary-Eerie-Black-Default, #232323);
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px; /* 171.429% */
          margin: 0;
        }
      }
    }
  }
  &-footer {
    box-shadow: 1px 0px 8px rgba(0, 0, 0, 0.15);
    padding: 16px;
    .footer-btn {
      text-align: center;
      background: $primary;
      color: #fff;
      font-weight: bold;
      height: 40px;
      line-height: 40px;
      border-radius: 8px;
      width: 100%;
      &.none {
        color: $dark !important;
        background: #fff !important;
        border: 1px solid #d1d5db;
      }
    }
  }
}
</style>
